require("hyphenopoly/Hyphenopoly_Loader");

(function selectiveLoad() {
    function handleSize(mql) {
        if (mql.matches) {
            try {
                Hyphenopoly.config({
                    require: {
                        "fr-fr": "FORCEHYPHENOPOLY",
                        "de": "Silbentrennungsalgorithmus",
                        "en-us": "FORCEHYPHENOPOLY"
                        // "en-us": "Supercalifragilisticexpialidocious"
                    },
                    fallbacks: {
                        "fr-fr": "fr",              //use de for de-DE
                    },
                    paths: {
                        // Path to the directory of pattern files
                        "patterndir": "/wp-content/themes/capgemini2020/dist/hyphenopoly/patterns/",
                        // Path to the directory where the other ressources are stored
                        "maindir": "/wp-content/themes/capgemini2020/dist/hyphenopoly/"
                    },
                    handleEvent: {
                        error: function (e) {
                            e.preventDefault(); //don't show error messages in console
                        }
                    },
                    setup: {
                        selectors: {
                            ".hero-bleed-mp-banner .content-box .title ": {
                                minWordLength: 12
                            },
                            ".heroCareersCard .heroCareersCardBoxTitle h1": {
                                minWordLength: 12
                            },
                            ".is-style-header--primary3 h1.box-title": {
                                minWordLength: 12
                            },
                            ".is-style-header--primary3 p.box-position": {
                                minWordLength: 12
                            },
                            ".heroPictureCard .heroPictureCardBoxTitle h1": {
                                minWordLength: 12
                            },
                            ".header-hero-press-release .header-title h1": {
                                minWordLength: 12
                            },
                            ".header-hero-press-release .header-description p": {
                                minWordLength: 12
                            },
                            ".heroReusable .box-title h1": {
                                minWordLength: 12
                            },
                            ".heroReusable h2.reasearchInsightTitle": {
                                minWordLength: 12
                            },
                            ".header-hero-blogs .header-title h1": {
                                minWordLength: 12
                            },
                            ".section--aboutus-boxes .content-title h3": {
                                minWordLength: 12
                            },
                            ".call-to-action-block h3.title": {
                                minWordLength: 12
                            },
                            ".section--event-slider-careerInvent .content-title h3": {
                                minWordLength: 20
                            },
                            ".section--event-slider-careerInvent .box-title h4": {
                                minWordLength: 20
                            },
                            ".section--event-slider-careerInvent .box-tag.expBlock": {
                                minWordLength: 20
                            },
                            ".section--event-slider-careerInvent .content-title.expBlock h3": {
                                minWordLength: 20
                            },
                            ".section--event-slider-careerInvent .box-title.expBlock h5": {
                                minWordLength: 20
                            },
                            ".card-tabs-block .content-title h3": {
                                minWordLength: 12
                            },
                            ".boardCommitteesBlock .box .box-title h3": {
                                minWordLength: 12
                            },
                            ".section--careers-stats.glassdoor .content-title h3": {
                                minWordLength: 12
                            },
                            ".column-text-block .column-text .column-title": {
                                minWordLength: 12
                            },
                            ".counter-para-section .content-title h3": {
                                minWordLength: 12
                            },
                            ".section-events-listing .event-section .event-list .event-title": {
                                minWordLength: 12
                            },
                            ".section-events-listing .event-section .event-list .event-agenda": {
                                minWordLength: 12
                            },
                            ".section--event-slider .section-title h3": {
                                minWordLength: 12
                            },
                            ".section--event-slider .event-slide .box-title": {
                                minWordLength: 12
                            },
                            ".section.section--expert-perspectives .content-title h3": {
                                minWordLength: 12
                            },
                            ".block-howwedoit .content-title h3": {
                                minWordLength: 12
                            },
                            ".section--intro .intro-para .intro-para-title": {
                                minWordLength: 12
                            },
                            ".keyInformation .contentTitle h3": {
                                minWordLength: 12
                            },
                            ".keyInformation .contentTitle h3": {
                                minWordLength: 12
                            },
                            ".latest-insights .insight-title h3": {
                                minWordLength: 12
                            },
                            "section.latest-news-block h3": {
                                minWordLength: 12
                            },
                            ".podcastBlock .content-title h3": {
                                minWordLength: 12
                            },
                            ".wp-block-cg-block-latest-reports h3": {
                                minWordLength: 12
                            },
                            ".latestStoriesBlock .contentTitle h3": {
                                minWordLength: 12
                            },
                            "section.learnMoreBlock .content-title h3": {
                                minWordLength: 12
                            },
                            ".regulated-agreement-block .content-title h3": {
                                minWordLength: 12
                            },
                            ".relatedContentBlock .content-title h3": {
                                minWordLength: 12
                            },
                            ".resource-static .box-inner h3": {
                                minWordLength: 12
                            },
                            ".relatedContentBlock .content-title h3": {
                                minWordLength: 12
                            },
                            ".social-media-block h3": {
                                minWordLength: 12
                            },
                            "section.card-related-capability .contentTitle h3": {
                                minWordLength: 12
                            },
                            ".wrapperCardTextPic .content-title h3": {
                                minWordLength: 12
                            },
                            "section.wp-block-cg-blocks-wrapper-client-stories.section-client-stories .content-title h3": {
                                minWordLength: 12
                            },
                            ".feature-content-slider .content-title h3": {
                                minWordLength: 12
                            },
                            ".get-in-touch-block .content-title h3": {
                                minWordLength: 12
                            },
                            ".section.section--partners-small .content-title h3, .section.section--partners-large .content-title h3": {
                                minWordLength: 12
                            },
                            ".wrapper-people-slider .content-title h3": {
                                minWordLength: 12
                            },

                        }
                    }
                });

                window.Hyphenopoly = Hyphenopoly;

            } catch (e) {
                console.warn("hyphenopoly warnings", e);
            }
        }
    }
    
    // Create a Media-Query-List
    const mql = window.matchMedia("(max-width: 768px)");
    // Listen to changes
    // window.addEventListener('resize',handleSize);
    // call handleSize on init
    handleSize(mql);
})();
